import { atRoundEnd, defineGameCard } from '../authoring/index.js';
export const ErraticReactorCard = defineGameCard({
    id: 'erratic_reactor',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 3, health: 4 } },
    presentation: {
        name: 'Нестабильный реактор',
        description: 'В конце каждого раунда его атака становится случайным числом от 2 до 7. Если выпало 6 или 7, он получает Перегрев 1.',
        glyph: {
            colors: ['#9388B7', '#6A7695', '#A89D5E'],
            rows: [
                '13323.111',
                '3.312123.',
                '12321..22',
                '.21321322',
                '211323332',
                '.212.13.3',
                '33222.311',
                '3322133..',
                '.2...2221',
            ],
        },
    },
    role: 'playable',
    abilities: [atRoundEnd((ctx) => {
            const self = ctx.self;
            if (self === undefined)
                return;
            const attack = ctx.rng.int(2, 7);
            ctx.ops.modifyStat(self.id, 'attack', attack - self.stats.attack);
            if (attack >= 6)
                ctx.ops.addHeat(self.id, 1);
        })],
    ui: { mechanics: ['heat'] },
});
//# sourceMappingURL=erratic_reactor.js.map